import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/newsreader/600.css';
import './styles.css';

import { render } from 'preact';

import { App } from './App';

const root = document.getElementById('app')!;
// The admin host gets the admin UI, loaded as its own chunk: participant pages never download it.
// Slug `admin` is reserved, so no organisation can have this host (SPEC §5).
if (location.hostname.startsWith('admin.')) void import('./admin/AdminApp').then(({ AdminApp }) => render(<AdminApp />, root));
else render(<App />, root);
